export default {
    CREATE: 'createView',
    EDIT: 'editView'
};
